export type ExecutionEventTypeValue = 7 | 8 | 9 | 10;

export type ExecutionEventOption = {
  value: ExecutionEventTypeValue;
  label: string;
};

export const executionEventOptions: ExecutionEventOption[] = [
  { value: 7, label: "On Time Pickup & Delivery" },
  { value: 8, label: "On Time Pickup, Late Delivery" },
  { value: 9, label: "On Time Delivery, Late Pickup" },
  { value: 10, label: "Failure To Pickup & Deliver On Time" }
];

export const executionEventTypeValues = new Set<number>(executionEventOptions.map(option => option.value));
